import { useCallback, useMemo, useState } from 'react'

import constate from 'constate'

const MAX_SELECTION = 100

export const [PropertiesDashboardContextProvider, usePropertiesDashboard] = constate(() => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set())

  const isSelected = useCallback((id: string) => selectedIds.has(id), [selectedIds])

  const toggleSelected = useCallback((id: string) => {
    setSelectedIds(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else if (next.size < MAX_SELECTION) next.add(id)
      return next
    })
  }, [])

  const selectMany = useCallback((ids: string[]) => {
    setSelectedIds(prev => {
      const next = new Set(prev)
      for (const id of ids) {
        if (next.size >= MAX_SELECTION) break
        next.add(id)
      }
      return next
    })
  }, [])

  const deselectMany = useCallback((ids: string[]) => {
    setSelectedIds(prev => {
      const next = new Set(prev)
      ids.forEach(id => next.delete(id))
      return next
    })
  }, [])

  const clearSelection = useCallback(() => setSelectedIds(new Set()), [])

  const selectedCount = useMemo(() => selectedIds.size, [selectedIds])
  const isSelectionFull = useMemo(() => selectedIds.size >= MAX_SELECTION, [selectedIds])

  return {
    selectedIds,
    isSelected,
    toggleSelected,
    selectMany,
    deselectMany,
    clearSelection,
    selectedCount,
    isSelectionFull,
  }
})
